import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const ChangePasswordDialog = ({ open, onOpenChange, forced }) => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: next });
      localStorage.setItem("momento_token", data.access_token);
      toast.success("Password changed");
      window.location.reload();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={forced ? () => {} : (v) => { if (!v) { setCur(""); setNext(""); setConfirm(""); } onOpenChange(v); }}>
      <DialogContent data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()}
        className={forced ? "[&>button:last-child]:hidden" : ""}>
        <DialogHeader>
          <DialogTitle>{forced ? "Choose your own password" : "Change password"}</DialogTitle>
          {forced && <DialogDescription>You signed in with a temporary password. Pick a new one to continue.</DialogDescription>}
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5"><Label>{forced ? "Temporary password" : "Current password"}</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>New password (min 8)</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="new-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirm new password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" /></div>
          {confirm && next !== confirm && <p className="text-xs text-destructive">Passwords don't match</p>}
        </div>
        <DialogFooter className="gap-2">
          {forced && <Button variant="ghost" onClick={() => { localStorage.removeItem("momento_token"); window.location.href = "/login"; }} data-testid="forced-signout-button">Sign out</Button>}
          <Button onClick={save} disabled={saving || !cur || next.length < 8 || next !== confirm} data-testid="change-password-save-button">Save password</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
